"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _reactModal = _interopRequireDefault(require("../../../components/reactModal"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var DeleteConfirmationModal = function DeleteConfirmationModal(_ref) {
  var isOpen = _ref.isOpen,
      onCancel = _ref.onCancel,
      onDelete = _ref.onDelete;
  return (0, _preact.h)(_reactModal.default, {
    isOpen: isOpen,
    onClose: onCancel
  }, (0, _preact.h)("div", {
    className: "unsaved-changes-modal"
  }, (0, _preact.h)("h3", {
    className: "modal-title"
  }, "Delete Campaign"), (0, _preact.h)("div", {
    className: "modal-description"
  }, "Are you sure you want to delete this campaign? This cannot be undone."), (0, _preact.h)(_Button.default, {
    size: "medium",
    variant: "danger",
    title: "Delete permanently ",
    onClick: onDelete,
    "data-track-type": "click",
    "data-element-name": "Delete permanently  button"
  }), (0, _preact.h)(_Button.default, {
    size: "medium",
    title: "Cancel",
    onClick: onCancel,
    "data-track-type": "click",
    "data-element-name": "Cancel button"
  })));
};

var _default = DeleteConfirmationModal;
exports.default = _default;